// extracted by mini-css-extract-plugin
export var button = "_c1-4";
export var hasDarkBackground = "_c1-7";
export var hasLightBackground = "_c1-6";
export var iconWrapper = "_c1-0";
export var large = "_c1-2";
export var medium = "_c1-1";
export var small = "_c1-5";
export var xsmall = "_c1-3";